module.exports = __webpack_public_path__ + "img/0.e080fef1.png";